var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticClass:"mt-21",attrs:{"lg":6,"md":6,"sm":24,"xs":24}},[_c('div',{staticClass:"fill fill-grey fill-sm skeleton"},[_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }